import * as React from 'react';
export const IcHammer = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 11.29l-.71-.7a2 2 0 00-1.41-.59H19a3 3 0 00-.7-3.12l-3.59-3.59a3.84 3.84 0 00-5.42 0 1 1 0 000 1.42l1 1a1.811 1.811 0 010 2.58 1.001 1.001 0 000 1.42l2.59 2.58A3 3 0 0016 13v.6a2 2 0 00.59 1.4l.7.71a1.002 1.002 0 001.42 0l3-3a1.002 1.002 0 000-1.42zm-12.26.4l-5.86 5.85A2 2 0 004.75 21H5a2 2 0 001.49-.66l5.56-6.11a6.108 6.108 0 01-.62-.52l-1.98-2.02z'
      fill='currentColor'
    />
  </svg>
);
